import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Briefcase, ChatCircle, Plus, MapPin } from "@phosphor-icons/react";

export default function CustomerDashboard() {
  const { user } = useAuth();
  const [jobs, setJobs] = useState([]);
  const [convs, setConvs] = useState([]);

  useEffect(() => {
    api.get("/jobs/mine").then((r) => setJobs(r.data));
    api.get("/conversations").then((r) => setConvs(r.data));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24 pb-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">Customer Dashboard</div>
            <h1 className="font-display text-4xl">Hi {user?.name?.split(" ")[0]}.</h1>
          </div>
          <Link to="/jobs/new" className="inline-flex items-center gap-2 bg-brand text-white px-5 py-3 font-semibold hover:bg-[#122148]" data-testid="post-job-btn">
            <Plus size={18} weight="bold" /> Post a job
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-10">
          <div className="border border-slate-200 p-6">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">My Jobs</div>
            <div className="font-display text-4xl mt-2">{jobs.length}</div>
          </div>
          <div className="border border-slate-200 p-6">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">Conversations</div>
            <div className="font-display text-4xl mt-2">{convs.length}</div>
          </div>
          <div className="border border-slate-200 p-6 bg-slate-900 text-white">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-300">Need help?</div>
            <Link to="/workers" className="font-display text-3xl mt-2 inline-block hover:underline">Browse Pros →</Link>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <section>
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-display text-2xl">Your jobs</h2>
              <Link to="/jobs/new" className="text-sm font-semibold text-brand">New →</Link>
            </div>
            {jobs.length === 0 ? (
              <div className="border border-dashed border-slate-300 p-8 text-center">
                <Briefcase size={28} className="mx-auto text-slate-400 mb-2" />
                <p className="text-sm text-slate-600 mb-3">You haven&apos;t posted any jobs yet.</p>
                <Link to="/jobs/new" className="text-sm font-semibold text-brand">Post your first job →</Link>
              </div>
            ) : (
              <div className="space-y-3">
                {jobs.map((j) => (
                  <Link key={j.job_id} to={`/jobs/${j.job_id}`} className="block border border-slate-200 p-4 hover:bg-slate-50" data-testid={`job-${j.job_id}`}>
                    <div className="flex items-center justify-between">
                      <div className="font-semibold">{j.title}</div>
                      <span className="text-[10px] uppercase tracking-wider bg-slate-100 px-2 py-0.5">{j.status}</span>
                    </div>
                    <div className="text-xs text-slate-500 mt-1 flex items-center gap-3"><span>{j.category}</span><span className="flex items-center gap-1"><MapPin size={12} /> {j.city}</span><span>${j.budget_min}–${j.budget_max}</span></div>
                  </Link>
                ))}
              </div>
            )}
          </section>

          <section>
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-display text-2xl">Conversations</h2>
              <Link to="/chat" className="text-sm font-semibold text-brand">All →</Link>
            </div>
            {convs.length === 0 ? (
              <div className="border border-dashed border-slate-300 p-8 text-center">
                <ChatCircle size={28} className="mx-auto text-slate-400 mb-2" />
                <p className="text-sm text-slate-600">No conversations yet.</p>
              </div>
            ) : (
              <div className="space-y-3">
                {convs.slice(0, 5).map((c) => {
                  const otherId = c.participants.find((p) => p !== user.user_id);
                  return (
                    <Link key={c.conversation_id} to={`/chat/${c.conversation_id}`} className="block border border-slate-200 p-4 hover:bg-slate-50">
                      <div className="font-semibold">{c.participant_names?.[otherId] || "Conversation"}</div>
                      <div className="text-sm text-slate-600 truncate">{c.last_message || "—"}</div>
                    </Link>
                  );
                })}
              </div>
            )}
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
